export const mockUser = {
  id: 'user_test_id',
  email: 'staff@weareopenr.com',
  firstName: 'Joe',
  lastName: 'Bloggs',
  emailVerified: true,
};

export const mockLocalStorage = (() => {
  let store: Record<string, unknown> = {};

  return {
    getItem(key: string | number) {
      return store[key] || null;
    },
    setItem(key: string | number, value: unknown) {
      store[key] = value;
    },
    clear() {
      store = {};
    },
    removeItem(key: string | number) {
      delete store[key];
    },
  };
})();
